import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useI18n } from '../i18n'
import { useMyFarm, useCreateFarm } from '../api/hooks'
import { Input, Textarea, PageSpinner } from '../components/ui'

export function FarmOnboarding() {
  const { t } = useI18n()
  const nav = useNavigate()
  const { data: farm, isLoading } = useMyFarm()
  const create = useCreateFarm()

  const [name, setName] = useState('')
  const [about, setAbout] = useState('')
  const [country, setCountry] = useState('')
  const [city, setCity] = useState('')
  const [addressLine, setAddressLine] = useState('')
  const [postcode, setPostcode] = useState('')
  const [phone, setPhone] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')

  if (isLoading) return <PageSpinner />
  // already has a farm → straight to the dashboard
  if (farm) {
    nav('/farm', { replace: true })
    return null
  }

  const submit = async () => {
    if (!name.trim()) {
      setErr(t('errors.required', { fields: t('farm.onboard.name') }))
      return
    }
    setErr('')
    setBusy(true)
    try {
      await create.mutateAsync({ name, about, country, city, addressLine, postcode, phone })
      nav('/farm', { replace: true })
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="mx-auto max-w-xl px-5 py-10">
      <div className="card p-8">
        <span className="chip mb-3">{t('farm.onboard.badge')}</span>
        <h1 className="text-2xl font-extrabold tracking-tight">{t('farm.onboard.title')}</h1>
        <p className="mt-1 text-brand-600 dark:text-brand-300">{t('farm.onboard.subtitle')}</p>

        <div className="mt-6 space-y-4">
          <Input label={t('farm.onboard.name')} value={name} onChange={setName} placeholder={t('farm.onboard.namePlaceholder')} required />
          <Textarea label={t('farm.onboard.about')} value={about} onChange={setAbout} rows={3} />
          <Input label={t('farm.uk.addressLine')} value={addressLine} onChange={setAddressLine} />
          <div className="grid grid-cols-2 gap-4">
            <Input label={t('farm.onboard.city')} value={city} onChange={setCity} />
            <Input label={t('farm.uk.postcode')} value={postcode} onChange={setPostcode} placeholder="GL54 1AB" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Input label={t('farm.onboard.country')} value={country} onChange={setCountry} />
            <Input label={t('farm.uk.phone')} value={phone} onChange={setPhone} />
          </div>
        </div>

        {err && <p className="mt-4 rounded-lg bg-red-50 dark:bg-red-900/30 px-3 py-2 text-sm font-semibold text-red-700 dark:text-red-300">{err}</p>}
        <button disabled={busy} onClick={submit} className="btn-primary mt-6 w-full disabled:opacity-60">
          {busy ? `${t('common.save')}…` : t('farm.onboard.cta')}
        </button>
      </div>
    </main>
  )
}
